import { useEffect, useState } from "react";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";
import { userSubscriptionState } from "@utils/constants/user";

function PromoBannerContainer() {
  const user = useCurrentUser();
  const locale = useLocale();
  const isLoggedIn = Boolean(user);
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));
  const paymentMethodValid = user?.default_payment_method?.valid;
  const subscriptionIsPastDue = user?.subscription?.state === subscriptionStatuses.pastDue;

  function shouldDisplayPromoBanner() {
    if (
      [userSubscriptionState.trialing, userSubscriptionState.active].includes(
        user?.subscription?.state,
      ) &&
      !paymentMethodValid
    )
      return false;
    if (subscriptionIsPastDue) return false;

    return true;
  }

  const [story, setStory] = useState();

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      if (!isLoggedIn) return;

      const storySlug = `common/promobanner/${process.env.NEXT_PUBLIC_CUSTOMER}/promo-banner`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };

      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    fetchStoryblokStory();
  }, [isLoggedIn, canPreview, locale]);

  if (!story || !shouldDisplayPromoBanner()) return null;

  return <StoryblokComponent story={story} />;
}

export default PromoBannerContainer;
